import Svg, {
  Text as SvgText,
  type PathProps,
  type SvgProps,
} from 'react-native-svg'

import {usePalette} from '#/lib/hooks/usePalette'

/*
 * The Cooey Club wordmark. Rendered as text (rather than the old Bluesky
 * letterform path) so it always reads "Cooey Club" and inherits the current
 * color. Authored in a 104x20 box; callers keep passing a width.
 */
const VB_W = 104
const VB_H = 20
const ratio = VB_H / VB_W

export function Logotype({
  fill,
  ...rest
}: {fill?: PathProps['fill']} & SvgProps) {
  const pal = usePalette('default')
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32)

  return (
    <Svg
      fill="none"
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      {...rest}
      width={size}
      height={Number(size) * ratio}>
      <SvgText
        x={VB_W / 2}
        y={15.5}
        fill={fill || pal.text.color}
        fontFamily="InterVariable, system-ui, sans-serif"
        fontSize={17}
        fontWeight="800"
        textAnchor="middle">
        Cooey Club
      </SvgText>
    </Svg>
  )
}
